import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import useStyles from "components/Auth/Register/RegisterStyles";
import { UILabels, UserRoleText, USER_PROP } from "components/User/constants";
import authActions from "../actions";
import { useSelector } from "react-redux";
import {
  checkEmailValid,
  checkFieldValid,
  checkPasswordStrength,
} from "components/User/Validation";
import { AppRouteURI } from "router/RoleBasedAccess";
import PasswordField from "components/common/PasswordField";

const RegisterView = () => {
  const [isFormValid, setIsFormValid] = useState(true);
  const {
    register,
    processInvite,
    setRegistration: setUser,
    loadInviteDetails,
  } = authActions();
  const { location } = useSelector((state) => state.router);
  const { register: user } = useSelector((state) => state.auth);
  const classes = useStyles();
  const hasToken = !!location["query"]["token"];

  const submitForm = (event) => {
    event.preventDefault();
    if (!hasToken) {
      register(user);
    } else {
      processInvite(user);
    }
  };
  const textfields = [
    USER_PROP.EMAIL,
    USER_PROP.FNAME,
    USER_PROP.LNAME,
    USER_PROP.PASSWORD,
  ];

  const [fieldChecked, setFieldChecked] = useState({
    ...Object.fromEntries(textfields.map((each) => [[each], false])),
  });

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    const checkFields =
      checkEmailValid(user[USER_PROP.EMAIL]) &&
      !!user[USER_PROP.FNAME] &&
      !!checkPasswordStrength(user[USER_PROP.PASSWORD]) &&
      !!user[USER_PROP.LNAME];
    setIsFormValid(checkFields);
  };

  const checkInviteField = (value) => {
    return (
      hasToken &&
      value === USER_PROP.EMAIL &&
      user[value] !== "" &&
      user["inviteType"] === "EMAIL"
    );
  };

  useEffect(() => {
    if (location["pathname"] === AppRouteURI.INVITATION) {
      loadInviteDetails();
    }
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {hasToken ? `Invitation for ${UserRoleText[user.role]}` : "Sign up"}
        </Typography>
        <form noValidate onSubmit={submitForm}>
          {textfields.map((value) => {
            return value !== "password" ? (
              <TextField
                variant="outlined"
                disabled={checkInviteField(value)}
                margin="normal"
                required
                fullWidth
                key={value}
                id={value}
                error={
                  fieldChecked[value] && !checkFieldValid(value, user[value])
                }
                onClick={() => {
                  setFieldChecked({
                    ...fieldChecked,
                    [value]: true,
                  });
                }}
                label={UILabels[value]}
                type={value === "password" ? value : undefined}
                name={value}
                autoComplete={value}
                value={user[value]}
                onChange={(e) => {
                  setUser({
                    ...user,
                    [value]: e.target.value,
                  });
                }}
              />
            ) : (
              <PasswordField
                variant="outlined"
                disabled={checkInviteField(value)}
                margin="normal"
                required
                fullWidth
                key={value}
                id={value}
                error={
                  fieldChecked[value] &&
                  !checkFieldValid(USER_PROP.PASSWORD, user[value])
                }
                onClick={() => {
                  setFieldChecked({
                    ...fieldChecked,
                    [value]: true,
                  });
                }}
                label={UILabels[value]}
                type="password"
                name={value}
                autoComplete={value}
                value={user[value]}
                onChange={(e) => {
                  setUser({
                    ...user,
                    [value]: e.target.value,
                  });
                }}
              />
            );
          })}
          <div className={classes.submit}>
            <Button
              type="submit"
              fullWidth
              disabled={!isFormValid}
              variant="contained"
              color="primary"
            >
              Register
            </Button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default RegisterView;
